@file:Suppress("REDUNDANT_VISIBILITY_MODIFIER")

package fr.manyverse.app

import kotlin.String
import kotlin.Suppress

internal object AppConfig {
  public val APP_VERSION: String = "1.21.0"

  public val BUILD_TIME: String = "2026-10-25"

  public val SUPABASE_URL: String = "https://cdgsbxwboerjeadtlvqv.supabase.co"

  public val SUPABASE_ANON_KEY: String =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNkZ3NieHdib2VyamVhZHRsdnF2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA3NjQ1NDEsImV4cCI6MjA3NjM0MDU0MX0.ZdvluRI8dlURBq4PrEsdw0nys_gutVSllruV57ud0Hc"

  public val GOOGLE_WEB_CLIENT_ID: String =
      "93359308933-gqngine2ueu5d5rsimijphrmijq1q6qe.apps.googleusercontent.com"

  public val SENTRY_DSN: String =
      "https://d07c6897c92d73008c0c69fd23e2e336@o4512171854004224.ingest.de.sentry.io/4512171860361296"
}
